<template>
  <div id="active-clinical-case">
    <div @click="goBack" class="go-back">
      <el-icon :size="15">
        <DArrowLeft />
      </el-icon>
      <span>Voltar</span>
    </div>
    <div
      class="active-clinical-case-form"
      v-if="isConsultant !== 'consultant_doctor' && formattedVoucherData"
    >
      <div class="half-width">
        <el-input v-model="formattedVoucherData.voucherId" disabled>
          <template #prepend>Caso Clínico nº</template>
        </el-input>
      </div>
      <div class="side-by-side">
        <div class="half-width">
          <el-input v-model="formattedVoucherData.specialtyName" disabled>
            <template #prepend>Especialidade</template>
          </el-input>
        </div>
        <div class="half-width with-margin">
          <el-input v-model="formattedVoucherData.diseaseName" disabled>
            <template #prepend>Doença</template>
          </el-input>
        </div>
      </div>
    </div>
    <QuestionnaireView
      v-if="isConsultant === 'consultant_doctor'"
      :voucher-data="formattedVoucherData"
    />

    <!-- Renderiza formulários específicos apenas para não consultants -->
    <template v-else>
      <AsmaGraveForm
        v-if="shouldShowAsmaForm"
        :is-edit="isEdit"
        :voucher-data="getVoucherInfos"
      />
      <ChronForm
        v-if="shouldShowChronForm"
        :is-edit="isEdit"
        :voucher-data="getVoucherInfos"
      />
    </template>
  </div>
</template>

<script>
import { PictureFilled, DArrowLeft } from '@element-plus/icons-vue'
import axios from 'axios'
import { useToast } from 'vue-toastification'
import { mapGetters, mapActions } from 'vuex'

import AsmaGraveForm from './components/AsmaGraveForm.vue'
import ChronForm from './components/ChronForm.vue'
import QuestionnaireView from './components/QuestionnaireView.vue'

import router from '@/router'

export default {
  components: {
    AsmaGraveForm,
    ChronForm,
    DArrowLeft,
    QuestionnaireView
  },
  setup() {
    const toast = useToast()

    return { toast }
  },
  data() {
    return {
      iconImg: PictureFilled,
      titleAsthma: 'Diagnóstico de Asma Grave',
      asthma: null,
      asthmaOptions: [
        {
          id: 1,
          name: 'Sim.'
        },
        {
          id: 2,
          name: 'Não.'
        }
      ],
      lungDiseases: null,
      lungDiseasesOptions: [
        {
          id: 1,
          name: 'Sim.'
        },
        {
          id: 2,
          name: 'Não.'
        }
      ],
      asthmaTreatment: null,
      asthmaTreatmentOptions: [
        {
          id: 1,
          name: 'Sim.'
        },
        {
          id: 2,
          name: 'Não.'
        }
      ],
      inhalation: null,
      inhalationOptions: [
        {
          id: 1,
          name: 'Sim.'
        },
        {
          id: 2,
          name: 'Não.'
        }
      ],
      error: null,
      isModalDashedErroVisible: false,
      titleComorbidities: 'Em relação a potenciais comorbidades.',
      comorbidities: null,
      comorbiditiesOptions: [
        {
          id: 1,
          name: 'Nenhuma.'
        },
        {
          id: 2,
          name: 'Rinite alérgica.'
        },
        {
          id: 3,
          name: 'Dermatite atópica.'
        },
        {
          id: 4,
          name: 'Sinusopatia crônica com polipose nasal.'
        },
        {
          id: 6,
          name: 'Obesidade.'
        },
        {
          id: 7,
          name: 'Apneia obstrutiva do sono.'
        },
        {
          id: 8,
          name: 'Refluxo gastroesofágico.'
        },
        {
          id: 9,
          name: 'Hipertensão arterial sistêmica.'
        },
        {
          id: 10,
          name: 'Diabetes.'
        },
        {
          id: 11,
          name: 'Outras.'
        }
      ],
      otherComorbidities: null,
      comorbiditiesInfo: null,
      comorbiditiesSelected: null,
      comorbiditiesSelectOptions: [
        {
          id: 1,
          name: 'Sim.'
        },
        {
          id: 2,
          name: 'Não.'
        }
      ],
      laba: null,
      labaOptions: [
        {
          id: 1,
          name: 'Sim.'
        },
        {
          id: 2,
          name: 'Não.'
        }
      ],
      asthmaMedications: null,
      immunobiological: null,
      immunobiologicalOptions: [
        {
          id: 1,
          name: 'Sim.'
        },
        {
          id: 2,
          name: 'Não.'
        }
      ],
      immunobiologicalDescription: null,
      titleExams: 'Exames adicionais',
      subtitleEspiro: 'Espirometria (último exame realizado)',
      espiroDate: null,
      preCvf: null,
      preVef: null,
      preVefCvf: null,
      preFef: null,
      posCvf: null,
      posVef: null,
      posVefCvf: null,
      posFef: null,
      bd: null,
      report: null,
      eosinophilsBlood: null,
      eosinophilsSputum: null,
      skinTest: null,
      skinOptions: [
        {
          id: 1,
          name: 'Sim.'
        },
        {
          id: 2,
          name: 'Não.'
        }
      ],
      ige: null,
      igeOptions: [
        {
          id: 1,
          name: 'Sim.'
        },
        {
          id: 2,
          name: 'Não.'
        }
      ],
      allergens: null,
      igeTotal: null,
      FeNO: null,
      plethysmography: null,
      dlco: null,
      ageStart: null,
      ageMonthStart: null,
      dust: null,
      dustOptions: [
        {
          id: 1,
          name: 'Sim.'
        },
        {
          id: 2,
          name: 'Não.'
        }
      ],
      pet: null,
      petOptions: [
        {
          id: 1,
          name: 'Sim.'
        },
        {
          id: 2,
          name: 'Não.'
        }
      ],
      petDescription: null,
      mold: null,
      moldOptions: [
        {
          id: 1,
          name: 'Sim.'
        },
        {
          id: 2,
          name: 'Não.'
        }
      ],
      exhibition: null,
      exhibitionOptions: [
        {
          id: 1,
          name: 'Sim.'
        },
        {
          id: 2,
          name: 'Não.'
        }
      ],
      exhibitionDescription: null,
      activeSmoking: null,
      activeSmokingOptions: [
        {
          id: 1,
          name: 'Sim.'
        },
        {
          id: 2,
          name: 'Não.'
        }
      ],
      passiveSmoking: null,
      passiveSmokingOptions: [
        {
          id: 1,
          name: 'Sim.'
        },
        {
          id: 2,
          name: 'Não.'
        }
      ],
      corticosteroid: null,
      corticosteroidOptions: [
        {
          id: 1,
          name: 'Sim.'
        },
        {
          id: 2,
          name: 'Não.'
        }
      ],
      corticosteroidTimes: null,
      hospitalization: null,
      hospitalizationOptions: [
        {
          id: 1,
          name: 'Sim.'
        },
        {
          id: 2,
          name: 'Não.'
        }
      ],
      hospitalizationTimes: null,
      uti: null,
      utiOptions: [
        {
          id: 1,
          name: 'Sim.'
        },
        {
          id: 2,
          name: 'Não.'
        }
      ],
      utiTimes: null,
      ventilation: null,
      ventilationOptions: [
        {
          id: 1,
          name: 'Sim.'
        },
        {
          id: 2,
          name: 'Não.'
        }
      ],
      ventilationTimes: null,
      pcr: null,
      pcrOptions: [
        {
          id: 1,
          name: 'Sim.'
        },
        {
          id: 2,
          name: 'Não.'
        }
      ],
      pcrTimes: null,
      medications: null,
      medicationsOptions: [
        {
          id: 1,
          name: 'Sim.'
        },
        {
          id: 2,
          name: 'Não.'
        }
      ],
      medicationsDescription: null,
      observations: null,
      questionsOrDoubts: null,
      gender: null,
      genderOptions: [
        {
          id: 2,
          name: 'Feminino.'
        },
        {
          id: 1,
          name: 'Masculino.'
        }
      ],
      age: null,
      color: null,
      colorOptions: [
        {
          id: 1,
          name: 'Branca.'
        },
        {
          id: 2,
          name: 'Preta.'
        },
        {
          id: 3,
          name: 'Parda.'
        },
        {
          id: 4,
          name: 'Amarela.'
        },
        {
          id: 5,
          name: 'Indígena.'
        }
      ],
      selectedFile: {},
      fileImg: null,
      activeDiseaseForm: null
    }
  },
  created() {
    if (!this.getVoucher.id) return router.push('/')
  },
  mounted() {
    if (this.getVoucher && this.getVoucher.id) {
      this.fetchVoucher(this.getVoucher.id)
    } else {
      console.error('No voucher ID found')
    }
    this.offActiveVoucherPage()
    this.fetchVoucher(this.getVoucher.id)
    this.verifyIsEdit(this.getVoucherInfos)
  },
  watch: {
    getActiveDisease: {
      immediate: true,
      handler(newDisease) {
        if (newDisease === 'Chron') {
          this.fetchVoucher(this.getVoucher.id)
        }
      }
    },
    getVoucherInfos() {
      this.verifyIsEdit(this.getVoucherInfos)
      this.handleData()
    },
    comorbidities() {
      if (!this.comorbidities?.includes(11))
        return this.clearOtherComorbidities()
    },

    immunobiological() {
      if (this.immunobiological === 2)
        return this.clearImmunobiologicalDescription()
    },

    pet() {
      if (this.pet === 2) return this.clearPetDescription()
    },

    exhibition() {
      if (this.exhibition === 2) return this.clearExhibitionDescription()
    },

    corticosteroid() {
      if (this.corticosteroid === 2) return (this.corticosteroidTimes = null)
    },

    hospitalization() {
      if (this.hospitalization === 2) return (this.hospitalizationTimes = null)
    },

    uti() {
      if (this.uti === 2) return (this.utiTimes = null)
    },

    ventilation() {
      if (this.ventilation === 2) return (this.ventilationTimes = null)
    },

    pcr() {
      if (this.pcr === 2) return (this.pcrTimes = null)
    },

    medications() {
      if (this.medications === 2) return (this.medicationsDescription = null)
    }
  },
  computed: {
    ...mapGetters(['getUserToken']),
    ...mapGetters('clinicalCasesEvaluation', ['getVoucher']),
    ...mapGetters('activeClinicalCases', [
      'getLoading',
      'getVoucherInfos',
      'getFile'
    ]),
    formattedVoucherData() {
      if (!this.getVoucherInfos || !this.getVoucherInfos.questionnaire)
        return null

      try {
        const questionnaire = JSON.parse(
          this.getVoucherInfos.questionnaire.replace(/'/g, '"')
        )

        return {
          voucherId: this.getVoucherInfos.voucherId || '',
          specialtyName: this.getVoucherInfos.specialtyName || '',
          diseaseName: this.getVoucherInfos.diseaseName || '',
          ...questionnaire,
          files: this.getFile
        }
      } catch (error) {
        console.error('Erro ao processar dados do questionário:', error)
        return {
          voucherId: this.getVoucherInfos.voucherId || '',
          specialtyName: this.getVoucherInfos.specialtyName || '',
          diseaseName: this.getVoucherInfos.diseaseName || '',
          files: this.getFile
        }
      }
    },
    shouldShowAsmaForm() {
      return this.getActiveDiseaseForm === 'asma_grave'
    },

    shouldShowChronForm() {
      return this.getActiveDiseaseForm === 'doenca_crohn'
    },

    isConsultant() {
      // Recuperar o tipo do localStorage
      const type = localStorage.getItem('user')
        ? JSON.parse(localStorage.getItem('user')).type
        : null

      // Retornar o tipo, ou uma string padrão se não. estiver definido
      return type || 'Tipo não. definido'
    },

    isOtherComorbiditiesDisabled() {
      return !this.comorbidities?.includes(11)
    },

    getActiveDisease() {
      return this.getVoucher?.diseaseName || ''
    },

    getActiveDiseaseForm() {
      // Usando contractName ou diseaseName para identificar o formulário
      const diseaseName =
        this.getVoucherInfos?.diseaseName?.toLowerCase().trim() ||
        this.getVoucherInfos?.contractName?.toLowerCase().trim() ||
        ''

        console.log('Nome da doença ativa:', diseaseName)

      // Mapeamento de nomes de doenças para tipos de formulário
      const diseaseFormMap = {
        crohn: 'doenca_crohn',
        'doença de crohn': 'doenca_crohn',
        'asma grave': 'asma_grave'
      }

      const form = diseaseFormMap[diseaseName] || ''
      console.log('Formulário ativo:', form)
      return form
    },

    cvf() {
      return 'CVF <sub style="vertical-align: sub;font-size: 70%">1</sub> <span style="color: red; font-size: 20px">*</span>'
    },

    vef() {
      return 'VEF <sub style="vertical-align: sub;font-size: 70%">1</sub> <span style="color: red; font-size: 20px">*</span>'
    },

    vefCvf() {
      return 'VEF <sub style="vertical-align: sub;font-size: 70%">1</sub>/CVF <span style="color: red; font-size: 20px">*</span>'
    },

    fef() {
      return 'FEF <sub style="vertical-align: sub;font-size: 70%">25% - 75%</sub>'
    },

    isLoading() {
      return this.getLoading
    },

    isEdit() {
      if (this.isConsultant === 'consultant_doctor') return false
      if (
        this.getVoucherInfos.length !== 0 &&
        this.getVoucherInfos?.status !== 'ativ'
      )
        return false
      return true
    },

    verifyOtherComorbidities() {
      if (this.isOtherComorbiditiesDisabled) return !this.otherComorbidities
      else return this.otherComorbidities
    },

    verifyImmunobiologicalDescription() {
      if (this.immunobiological === 2) return !this.immunobiologicalDescription
      else return this.immunobiologicalDescription
    },

    verifyPet() {
      if (this.pet === 2) return !this.petDescription
      else return this.petDescription
    },

    verifyExhibition() {
      if (this.exhibition === 2) return !this.exhibitionDescription
      else return this.exhibitionDescription
    },

    verifyCorticosteroid() {
      if (this.corticosteroid === 2) return !this.corticosteroidTimes
      else return this.corticosteroidTimes
    },

    verifyHospitalization() {
      if (this.hospitalization === 2) return !this.hospitalizationTimes
      else return this.hospitalizationTimes
    },

    verifyTimes() {
      if (this.uti === 2) return !this.utiTimes
      else return this.utiTimes
    },

    verifyVentilation() {
      if (this.ventilation === 2) return !this.ventilationTimes
      else return this.ventilationTimes
    },

    verifyPcr() {
      if (this.pcr === 2) return !this.pcrTimes
      else return this.pcrTimes
    },

    verifyMedications() {
      if (this.medications === 2) return !this.medicationsDescription
      else return this.medicationsDescription
    },

    handleEnabledSubmit() {
      return (
        !this.age ||
        !this.gender ||
        !this.color ||
        !this.asthma ||
        !this.lungDiseases ||
        !this.asthmaTreatment ||
        !this.inhalation ||
        !this.comorbidities ||
        !this.verifyOtherComorbidities ||
        !this.laba ||
        !this.espiroDate ||
        !this.asthmaMedications ||
        !this.immunobiological ||
        !this.verifyImmunobiologicalDescription ||
        !this.preCvf ||
        !this.preVef ||
        !this.preVefCvf ||
        !this.posCvf ||
        !this.posVef ||
        !this.posVefCvf ||
        !this.bd ||
        !this.report ||
        !this.eosinophilsBlood ||
        !this.skinTest ||
        !this.ige ||
        !this.allergens ||
        !this.igeTotal ||
        !this.ageStart ||
        !this.ageMonthStart ||
        !this.dust ||
        !this.pet ||
        !this.verifyPet ||
        !this.mold ||
        !this.exhibition ||
        !this.verifyExhibition ||
        !this.activeSmoking ||
        !this.passiveSmoking ||
        !this.corticosteroid ||
        !this.verifyCorticosteroid ||
        !this.hospitalization ||
        !this.verifyHospitalization ||
        !this.uti ||
        !this.verifyTimes ||
        !this.ventilation ||
        !this.verifyVentilation ||
        !this.pcr ||
        !this.verifyPcr ||
        !this.medications ||
        !this.verifyMedications ||
        !this.comorbiditiesSelected
      )
    }
  },
  methods: {
    ...mapActions('activeClinicalCases', [
      'fechVoucherDownload',
      'saveEditVoucher',
      'activeVoucher',
      'fetchVoucher',
      'fetchFile'
    ]),
    ...mapActions('clinicalCasesEvaluation', ['offActiveVoucherPage']),

    async fetchVoucher(id) {
      if (!id) {
        console.error('ID do voucher não fornecido')
        return
      }

      try {
        await this.$store.dispatch('activeClinicalCases/fetchVoucher', id)
        this.handleData()
      } catch (error) {
        console.error('Erro ao buscar voucher:', error)
      }
    },

    handleKeyDown(event) {
      // Permite apenas entrada numérica, a tecla Backspace, Tab e ações de cursor
      const isNumeric = /^[0-9]$/.test(event.key)
      const isBackspace = event.key === 'Backspace'
      const isTab = event.key === 'Tab'
      const isCursorAction =
        event.key.startsWith('Arrow') ||
        event.key.startsWith('Home') ||
        event.key.startsWith('End')

      if (!(isNumeric || isBackspace || isTab || isCursorAction)) {
        event.preventDefault()
      }
    },
    verifyPreCvf() {
      // Remove caracteres não numéricos e garante que o valor seja um número
      let numericValue = parseFloat(this.preCvf?.replace(/[^0-9]/g, ''))

      if (isNaN(numericValue)) {
        numericValue = 0
      }

      // Garante que o valor não ultrapasse 100
      numericValue = Math.min(100, numericValue)

      // Atualiza o valor formatado
      this.preCvf = `${numericValue}%`
    },

    clearOtherComorbidities() {
      this.otherComorbidities = null
    },

    clearImmunobiologicalDescription() {
      this.immunobiologicalDescription = null
    },

    clearPetDescription() {
      this.petDescription = null
    },

    clearExhibitionDescription() {
      this.exhibitionDescription = null
    },

    // verifyPreCvf() {
    //   if (parseInt(this.preCvf) > 100) return (this.preCvf = '100%')
    // },

    verifyPreVef() {
      let numericValue = parseFloat(this.preVef?.replace(/[^0-9]/g, ''))
      if (isNaN(numericValue)) {
        numericValue = 0
      }

      // Garante que o valor não ultrapasse 100
      numericValue = Math.min(100, numericValue)

      // Atualiza o valor formatado
      this.preVef = `${numericValue}%`
    },

    verifyPreVefCvf() {
      let numericValue = parseFloat(this.preVefCvf?.replace(/[^0-9]/g, ''))
      if (isNaN(numericValue)) {
        numericValue = 0
      }

      // Garante que o valor não ultrapasse 100
      numericValue = Math.min(100, numericValue)

      // Atualiza o valor formatado
      this.preVefCvf = `${numericValue}%`
    },

    verifyPreFef() {
      if (!this.preFef) return

      let numericValue = parseFloat(this.preFef?.replace(/[^0-9]/g, ''))
      if (isNaN(numericValue)) {
        numericValue = 0
      }

      // Garante que o valor não ultrapasse 100
      numericValue = Math.min(100, numericValue)

      // Atualiza o valor formatado
      this.preFef = `${numericValue}%`
    },

    verifyPosCvf() {
      let numericValue = parseFloat(this.posCvf?.replace(/[^0-9]/g, ''))
      if (isNaN(numericValue)) {
        numericValue = 0
      }

      // Garante que o valor não ultrapasse 100
      numericValue = Math.min(100, numericValue)

      // Atualiza o valor formatado
      this.posCvf = `${numericValue}%`
    },

    verifyAgeMonthStart() {
      if (this.ageMonthStart > 12) return (this.ageMonthStart = 12)
    },

    verifyPosVef() {
      let numericValue = parseFloat(this.posVef?.replace(/[^0-9]/g, ''))
      if (isNaN(numericValue)) {
        numericValue = 0
      }

      // Garante que o valor não ultrapasse 100
      numericValue = Math.min(100, numericValue)

      // Atualiza o valor formatado
      this.posVef = `${numericValue}%`
    },

    verifyPosVefCvf() {
      let numericValue = parseFloat(this.posVefCvf?.replace(/[^0-9]/g, ''))
      if (isNaN(numericValue)) {
        numericValue = 0
      }

      // Garante que o valor não ultrapasse 100
      numericValue = Math.min(100, numericValue)

      // Atualiza o valor formatado
      this.posVefCvf = `${numericValue}%`
    },

    verifyPosFef() {
      if (!this.posFef) return

      let numericValue = parseFloat(this.posFef?.replace(/[^0-9]/g, ''))
      if (isNaN(numericValue)) {
        numericValue = 0
      }

      // Garante que o valor não ultrapasse 100
      numericValue = Math.min(100, numericValue)

      // Atualiza o valor formatado
      this.posFef = `${numericValue}%`
    },

    verifyBd() {
      let numericValue = parseFloat(this.bd?.replace(/[^0-9]/g, ''))
      if (isNaN(numericValue)) {
        numericValue = 0
      }

      // Garante que o valor não ultrapasse 100
      numericValue = Math.min(100, numericValue)

      // Atualiza o valor formatado
      this.bd = `${numericValue}%`
    },

    verifyEosinophilsBlood() {
      let numericValue = parseFloat(
        this.eosinophilsBlood?.replace(/[^0-9]/g, '')
      )
      if (isNaN(numericValue)) {
        numericValue = 0
      }

      // Atualiza o valor formatado
      this.eosinophilsBlood = `${numericValue}céls/mm³`
    },

    verifyEosinophilsSputum() {
      let numericValue = parseFloat(
        this.eosinophilsSputum?.replace(/[^0-9]/g, '')
      )
      if (isNaN(numericValue)) {
        numericValue = 0
      }

      // Garante que o valor não ultrapasse 100
      numericValue = Math.min(100, numericValue)

      // Atualiza o valor formatado
      this.eosinophilsSputum = `${numericValue}%`
    },

    verifyIgeTotal() {
      let numericValue = parseFloat(this.igeTotal?.replace(/[^0-9]/g, ''))
      if (isNaN(numericValue)) {
        numericValue = 0
      }

      // Atualiza o valor formatado
      this.igeTotal = `${numericValue}UI/ml`
    },

    verifyFeNO() {
      let numericValue = parseFloat(this.FeNO?.replace(/[^0-9]/g, ''))
      if (isNaN(numericValue)) {
        numericValue = 0
      }

      // Atualiza o valor formatado
      this.FeNO = `${numericValue}ppm`
    },

    handleDownload(id, name) {
      const fileData = {
        id: id,
        name: name
      }
      this.fechVoucherDownload(fileData)
    },

    goBack() {
      if (this.isConsultant === 'consultant_doctor')
        return router.push('/clinical-cases-consultation-doctor')
      else router.push('/clinical-cases-evaluation')
    },

    handleSave() {
      const userData = {
        data: JSON.stringify({
          age: this.age,
          gender: this.gender,
          color: this.color,
          asthma: this.asthma,
          lungDiseases: this.lungDiseases,
          asthmaTreatment: this.asthmaTreatment,
          comorbiditiesSelected: this.comorbiditiesSelected,
          inhalation: this.inhalation,
          comorbidities: this.comorbidities,
          otherComorbidities: this.otherComorbidities,
          comorbiditiesInfo: this.comorbiditiesInfo,
          laba: this.laba,
          asthmaMedications: this.asthmaMedications,
          immunobiological: this.immunobiological,
          immunobiologicalDescription: this.immunobiologicalDescription,
          espiroDate: this.espiroDate,
          preCvf: this.preCvf,
          preVef: this.preVef,
          preVefCvf: this.preVefCvf,
          preFef: this.preFef,
          posCvf: this.posCvf,
          posVef: this.posVef,
          posVefCvf: this.posVefCvf,
          posFef: this.posFef,
          bd: this.bd,
          report: this.report,
          eosinophilsBlood: this.eosinophilsBlood,
          eosinophilsSputum: this.eosinophilsSputum,
          skinTest: this.skinTest,
          ige: this.ige,
          allergens: this.allergens,
          igeTotal: this.igeTotal,
          FeNO: this.FeNO,
          plethysmography: this.plethysmography,
          dlco: this.dlco,
          ageStart: this.ageStart,
          ageMonthStart: this.ageMonthStart,
          dust: this.dust,
          pet: this.pet,
          petDescription: this.petDescription,
          mold: this.mold,
          exhibition: this.exhibition,
          exhibitionDescription: this.exhibitionDescription,
          activeSmoking: this.activeSmoking,
          passiveSmoking: this.passiveSmoking,
          corticosteroid: this.corticosteroid,
          corticosteroidTimes: this.corticosteroidTimes,
          hospitalization: this.hospitalization,
          hospitalizationTimes: this.hospitalizationTimes,
          uti: this.uti,
          utiTimes: this.utiTimes,
          ventilation: this.ventilation,
          ventilationTimes: this.ventilationTimes,
          pcr: this.pcr,
          pcrTimes: this.pcrTimes,
          medications: this.medications,
          medicationsDescription: this.medicationsDescription,
          observations: this.observations,
          questionsOrDoubts: this.questionsOrDoubts
        }),
        voucherId: this.getVoucher.id
      }
      this.saveEditVoucher(userData)
    },

    async handleActiveVoucher() {
      const userData = {
        data: JSON.stringify({
          age: this.age,
          gender: this.gender,
          color: this.color,
          asthma: this.asthma,
          lungDiseases: this.lungDiseases,
          asthmaTreatment: this.asthmaTreatment,
          comorbiditiesSelected: this.comorbiditiesSelected,
          inhalation: this.inhalation,
          comorbidities: this.comorbidities,
          otherComorbidities: this.otherComorbidities,
          comorbiditiesInfo: this.comorbiditiesInfo,
          laba: this.laba,
          asthmaMedications: this.asthmaMedications,
          immunobiological: this.immunobiological,
          immunobiologicalDescription: this.immunobiologicalDescription,
          espiroDate: this.espiroDate,
          preCvf: this.preCvf,
          preVef: this.preVef,
          preVefCvf: this.preVefCvf,
          preFef: this.preFef,
          posCvf: this.posCvf,
          posVef: this.posVef,
          posVefCvf: this.posVefCvf,
          posFef: this.posFef,
          bd: this.bd,
          report: this.report,
          eosinophilsBlood: this.eosinophilsBlood,
          eosinophilsSputum: this.eosinophilsSputum,
          skinTest: this.skinTest,
          ige: this.ige,
          allergens: this.allergens,
          igeTotal: this.igeTotal,
          FeNO: this.FeNO,
          plethysmography: this.plethysmography,
          dlco: this.dlco,
          ageStart: this.ageStart,
          ageMonthStart: this.ageMonthStart,
          dust: this.dust,
          pet: this.pet,
          petDescription: this.petDescription,
          mold: this.mold,
          exhibition: this.exhibition,
          exhibitionDescription: this.exhibitionDescription,
          activeSmoking: this.activeSmoking,
          passiveSmoking: this.passiveSmoking,
          corticosteroid: this.corticosteroid,
          corticosteroidTimes: this.corticosteroidTimes,
          hospitalization: this.hospitalization,
          hospitalizationTimes: this.hospitalizationTimes,
          uti: this.uti,
          utiTimes: this.utiTimes,
          ventilation: this.ventilation,
          ventilationTimes: this.ventilationTimes,
          pcr: this.pcr,
          pcrTimes: this.pcrTimes,
          medications: this.medications,
          medicationsDescription: this.medicationsDescription,
          observations: this.observations,
          questionsOrDoubts: this.questionsOrDoubts
        }),
        voucherId: this.getVoucher.id
      }
      try {
        await this.activeVoucher(userData)
        await this.fetchVoucher(this.getVoucher.id)
        this.verifyIsEdit(this.getVoucherInfos)
      } catch (error) {
        console.error('Erro ao ativar voucher:', error)
      }
    },

    handleFile(event) {
      this.selectedFile = event.target.files[0]
    },

    async handleFileImg(file) {
      this.selectedFile = file.raw

      await this.submit()
    },

    async submit() {
      const url = process.env.VUE_APP_CLINICAL_CASE_API
      const voucherId = this.getVoucher.id
      const formData = new FormData()
      formData.append('body', this.selectedFile)

      await axios
        .post(`${url}/voucher/${voucherId}/document`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${this.getUserToken}`
          }
        })
        .then(() => {
          this.toast.success('Upload realizado com sucesso', {
            timeout: 8000
          })
        })
        .catch(() => {
          this.toast.warning('Não. foi possível realizar o upload do arquivo')
        })
        .finally(() => {
          this.fetchFile(voucherId)
        })
    },

    verifyIsEdit(getVoucherInfos) {
      if (getVoucherInfos?.status !== 'ativ') {
        this.isEdit = false
        return
      }

      this.isEdit = true
    },

    handleData() {
      const questionnaire = this.getVoucherInfos.questionnaire
      if (!questionnaire) return

      const jsonString = questionnaire
      const jsonObject = JSON.parse(jsonString.replace(/'/g, '"'))

      this.age = jsonObject?.age
      this.gender = jsonObject?.gender
      this.color = jsonObject?.color
      this.asthma = jsonObject?.asthma
      this.lungDiseases = jsonObject?.lungDiseases
      this.asthmaTreatment = jsonObject?.asthmaTreatment
      this.comorbiditiesSelected = jsonObject?.comorbiditiesSelected
      this.inhalation = jsonObject?.inhalation
      this.comorbidities = jsonObject?.comorbidities
      this.otherComorbidities = jsonObject?.otherComorbidities
      this.comorbiditiesInfo = jsonObject?.comorbiditiesInfo
      this.laba = jsonObject?.laba
      this.asthmaMedications = jsonObject?.asthmaMedications
      this.immunobiological = jsonObject?.immunobiological
      this.immunobiologicalDescription = jsonObject?.immunobiologicalDescription
      this.espiroDate = jsonObject?.espiroDate
      this.preCvf = jsonObject?.preCvf
      this.preVef = jsonObject?.preVef
      this.preVefCvf = jsonObject?.preVefCvf
      this.preFef = jsonObject?.preFef
      this.posCvf = jsonObject?.posCvf
      this.posVef = jsonObject?.posVef
      this.posVefCvf = jsonObject?.posVefCvf
      this.posFef = jsonObject?.posFef
      this.bd = jsonObject?.bd
      this.report = jsonObject?.report
      this.eosinophilsBlood = jsonObject?.eosinophilsBlood
      this.eosinophilsSputum = jsonObject?.eosinophilsSputum
      this.skinTest = jsonObject?.skinTest
      this.ige = jsonObject?.ige
      this.allergens = jsonObject?.allergens
      this.igeTotal = jsonObject?.igeTotal
      this.FeNO = jsonObject?.FeNO
      this.plethysmography = jsonObject?.plethysmography
      this.dlco = jsonObject?.dlco
      this.ageStart = jsonObject?.ageStart
      this.ageMonthStart = jsonObject?.ageMonthStart
      this.dust = jsonObject?.dust
      this.pet = jsonObject?.pet
      this.petDescription = jsonObject?.petDescription
      this.mold = jsonObject?.mold
      this.exhibition = jsonObject?.exhibition
      this.exhibitionDescription = jsonObject?.exhibitionDescription
      this.activeSmoking = jsonObject?.activeSmoking
      this.passiveSmoking = jsonObject?.passiveSmoking
      this.corticosteroid = jsonObject?.corticosteroid
      this.corticosteroidTimes = jsonObject?.corticosteroidTimes
      this.hospitalization = jsonObject?.hospitalization
      this.hospitalizationTimes = jsonObject?.hospitalizationTimes
      this.uti = jsonObject?.uti
      this.utiTimes = jsonObject?.utiTimes
      this.ventilation = jsonObject?.ventilation
      this.ventilationTimes = jsonObject?.ventilationTimes
      this.pcr = jsonObject?.pcr
      this.pcrTimes = jsonObject?.pcrTimes
      this.medications = jsonObject?.medications
      this.medicationsDescription = jsonObject?.medicationsDescription
      this.observations = jsonObject?.observations
      this.questionsOrDoubts = jsonObject?.questionsOrDoubts
    }
  }
}
</script>

<style lang="scss" scoped>
#active-clinical-case {
  width: 100%;

  .go-back {
    position: fixed;
    bottom: 100px;
    right: 40px;
    cursor: pointer;
    color: $grayDark;
    display: flex;
    align-items: center;

    span {
      margin-left: 5px;
      transition: 0.5s;

      &:hover {
        text-decoration: underline;
        color: $grayDark;
      }
    }

    i {
      background: $green-500;
      color: white;
      border-radius: 19%;
      margin-left: 5px;
    }
  }
}

.full-width {
  width: 100%;
  padding-bottom: 15px;
}

.side-by-side {
  display: flex;
  flex-wrap: wrap;
}

.half-width {
  flex: 1;
  margin-bottom: 10px;
}

.with-margin {
  margin-left: 20px;
}

.content-subtitle {
  flex-direction: column;
  align-items: left;
  text-align: left;
  display: flex;
  padding: 10px 20px;

  .title {
    color: $green-500;
  }
}

.content-title {
  flex-direction: column;
  margin-bottom: 25px;
  align-items: left;
  text-align: left;
  display: flex;
  padding: 30px 20px 0 20px;

  .title {
    color: $green-500;
  }

  .line {
    background-color: $green-500;
    margin-top: 15px;
    bottom: -15px;
    width: 60px;
    height: 5px;
  }
}

.btn {
  padding: 10px 0 20px 0;
  display: flex;
  place-content: end;

  .save {
    width: 150px;
  }

  .send {
    width: 250px;
  }
}

label {
  height: 14px;
  margin: 10px 0;
  font-size: 14px;
  font-weight: 600;
  color: $grayDark;
}

.intro-doc {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 20px;

  p {
    text-align: justify;
    font-size: 14px;
    font-weight: 600;
    color: $grayDark;
  }
}

.filepath {
  display: flex;
  align-items: center;
  margin: 20px;

  .filename {
    font-size: 14px;
    cursor: pointer;
    transition: 0.2s;

    &:hover {
      border-bottom: 1px solid #000;
    }
  }
}
</style>
